"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPage = exports.createBlock = exports.clearBlockByUid = exports.clearBlockById = exports.updateActiveBlock = void 0;
const dom_1 = require("./dom");
const updateActiveBlock = (text) => window.roamAlphaAPI.updateBlock({
    block: {
        uid: dom_1.getActiveUids().blockUid,
        string: text,
    },
});
exports.updateActiveBlock = updateActiveBlock;
const clearBlockById = (id) => window.roamAlphaAPI.updateBlock({
    block: {
        uid: dom_1.getUidsFromId(id).blockUid,
        string: "",
    },
});
exports.clearBlockById = clearBlockById;
const clearBlockByUid = (uid) => window.roamAlphaAPI.updateBlock({
    block: {
        uid,
        string: "",
    },
});
exports.clearBlockByUid = clearBlockByUid;
const createBlock = ({ node, parentUid, order = 0, }) => {
    const uid = window.roamAlphaAPI.util.generateUID();
    window.roamAlphaAPI.createBlock({
        location: { "parent-uid": parentUid, order },
        block: { uid, string: node.text },
    });
    (node.children || []).forEach((n, o) => exports.createBlock({ node: n, parentUid: uid, order: o }));
    return uid;
};
exports.createBlock = createBlock;
const createPage = ({ title, tree, }) => {
    const uid = window.roamAlphaAPI.util.generateUID();
    window.roamAlphaAPI.createPage({ page: { title, uid } });
    tree.forEach((node, order) => exports.createBlock({ node, parentUid: uid, order }));
    return uid;
};
exports.createPage = createPage;
